import React, { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import Footer from './components/Footer';
import Header from './components/Header';
import './Functional.css'; 


function ResetPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handlePasswordReset = async () => {
    const auth = getAuth();
    try {
      await sendPasswordResetEmail(auth, email);
      setMessage("Thanks, if we find your email address in our system we will send you a password reset link.");
    } catch (error) {
      setMessage(`Error: ${error.message}`);
    }
  };

  return (
    <div className="properties-page">
      <Header />
      <div className="my-account-content">
        <section style={{maxWidth:'600px'}}>
          <h2>Reset Your Password</h2>
          <p style={{marginTop:"0px"}}>Enter your email address, and we’ll send you a link to reset your password.</p>
          <input
            className='reset-input'
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={{ padding: '10px', width: '100%', marginBottom: '20px', marginTop: '0px', maxWidth: '320px' }}
          /><br/>
          <button
            className="property-action-button"
            onClick={handlePasswordReset}
            style={{ marginBottom: '10px' }}
          >
            Send Reset Link
          </button>
          {message && <p style={{ marginBottom: "0px", color: message.includes('Error') ? 'red' : 'black' }}>{message}</p>}
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default ResetPassword;
